// extracted by mini-css-extract-plugin
export default {"parameter":"S6swZ","name":"aIK0w"};